import React, { useState } from 'react';
import SideModal from '@design-system/SideCart/SideModal';
import PropTypes from 'prop-types';
import { Box, ModalHeader, Categories, Price } from './filterModal.style';
import { AiOutlineCheck } from 'react-icons/ai';
import { price } from '../hooks/enums';
import commaNumber from 'comma-number';

const FilterModal = ({
  isOpen,
  toggle,
  categories,
  handleSelectedFilter,
  selectedFilter,
  activateFilter,
  resetMobileFilter,
  seller,
  handleMobilePriceFilter,
  lowprice,
}) => {
  return (
    <SideModal isOpen={isOpen} toggle={toggle}>
      <Box>
        <ModalHeader>
          <div></div>
          <div className="title">Filter</div>
          {selectedFilter !== '' ? (
            <div onClick={resetMobileFilter} className="clear">
              Clear all
            </div>
          ) : (
            <div></div>
          )}
        </ModalHeader>

        <CategoriesSection
          categories={categories}
          handleSelectedFilter={handleSelectedFilter}
          selectedFilter={selectedFilter}
        />

        <PriceSection
          seller={seller}
          handleMobilePriceFilter={handleMobilePriceFilter}
          lowprice={lowprice}
        />

        <button onClick={activateFilter}>Save</button>
      </Box>
    </SideModal>
  );
};

export default FilterModal;

FilterModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  categories: PropTypes.object.isRequired,
  handleSelectedFilter: PropTypes.func.isRequired,
  selectedFilter: PropTypes.string.isRequired,
  activateFilter: PropTypes.func.isRequired,
  resetMobileFilter: PropTypes.func.isRequired,
  seller: PropTypes.object.isRequired,
  lowprice: PropTypes.string.isRequired,
  handleMobilePriceFilter: PropTypes.func.isRequired,
};

const CategoriesSection = ({ categories, handleSelectedFilter, selectedFilter }) => {
  const [visibleItems, setVisibileItems] = useState(5);

  const showMore = () => {
    setVisibileItems(visibleItems + 5);
  };

  return (
    <Categories>
      <div className="title">Categories</div>
      <div className="category">
        {categories.slice(0, visibleItems).map((data) => (
          <div
            key={data._id}
            className="container"
            onClick={() => handleSelectedFilter(data)}
          >
            <div style={{ display: 'inline-block' }}>
              <div
                className={
                  selectedFilter === data._id ? 'checkbox_selected' : 'checkbox'
                }
              >
                {' '}
                {selectedFilter === data._id ? (
                  <AiOutlineCheck color="#fff" size={12} />
                ) : null}{' '}
              </div>
            </div>
            <div className="name">{data.name}</div>
          </div>
        ))}
        {visibleItems < categories.length ? (
          <div onClick={showMore} className="show">
            Show more{`(${categories.length - visibleItems})`}
          </div>
        ) : (
          <div onClick={() => setVisibileItems(5)} className="show">
            {' '}
            Hide{' '}
          </div>
        )}
      </div>
    </Categories>
  );
};

CategoriesSection.propTypes = {
  categories: PropTypes.object.isRequired,
  handleSelectedFilter: PropTypes.func.isRequired,
  selectedFilter: PropTypes.string.isRequired,
};

const PriceSection = ({ seller, lowprice, handleMobilePriceFilter }) => {
  return (
    <Price>
      <div className="title">Price</div>
      <div className="body">
        {price.map((price, idx) => (
          <div
            className="container"
            key={idx}
            onClick={() => handleMobilePriceFilter(price)}
          >
            <div style={{ display: 'inline-block' }}>
              <div
                className={
                  Number(lowprice) === price.low ? 'checkbox_selected' : 'checkbox'
                }
              >
                {' '}
                {Number(lowprice) === price.low ? (
                  <AiOutlineCheck color="#fff" size={12} />
                ) : null}{' '}
              </div>
            </div>
            <div className="name">
              {`${seller?.currency?.symbol}${commaNumber(price.low)} - ${
                seller?.currency?.symbol
              }${commaNumber(price.high)}`}
            </div>
          </div>
        ))}
      </div>
    </Price>
  );
};

PriceSection.propTypes = {
  seller: PropTypes.object.isRequired,
  lowprice: PropTypes.string.isRequired,
  handleMobilePriceFilter: PropTypes.func.isRequired,
};
